<template lang="pug">
#bloco-inserir-dados-analise-rastreabilidade
    h1 {{ $t('mensagens.relatorioRastreabilidade.cadastro.paraRealizarNovaConsultaDigiteCpfCnpjSelecioneCar') }}
    el-card
        .box-inserir-dados-analise
            .box-inserir-dados-analise__conteudo
                .box-inserir-dados-analise__conteudo__bloco
                    el-form.box-inserir-dados-analise__conteudo__bloco_pesquisa(
                        label-position='top',
                        :model='formularioCadastroTerritorio',
                        :rules='formularioCadastroTerritorioRegras',
                        ref='formularioCadastroTerritorio'
                    )
                        .box-card-inserir-dados-analise
                            el-form-item(prop='safra')
                                template(slot='label')
                                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.ciclo') + '/' + $t('mensagens.relatorioRastreabilidade.cadastro.ano') }}

                                    .select-pesquisa-por-territorio
                                        el-select#safra(
                                            v-model='formularioCadastroTerritorio.safra',
                                            clearable,
                                            filterable,
                                            :loading='loading.safras',
                                            :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.selecione")'
                                        )
                                            el-option(
                                                v-for='({ ano, id }, index) in safras',
                                                :key='id + ano',
                                                :id='"safra-" + ano',
                                                :label='ano',
                                                :value='ano'
                                            )

                        .box-inserir-dados-analise__conteudo__bloco_pesquisa-por-territorio.width-direito
                            el-form-item(prop='cpfCnpj')
                                template(slot='label')
                                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.pesquisaCpfCnpj') }}
                                    el-tooltip(
                                        :content='$t("mensagens.relatorioRastreabilidade.cadastro.informeCpfCnpjProdutor")',
                                        placement='top'
                                    )
                                        i.el-icon-info.dados-manual

                                .input-pesquisa-por-territorio.input-car-cpf-cnpj
                                    el-input(
                                        v-model='formularioCadastroTerritorio.cpfCnpj',
                                        @clear='limparCPF',
                                        :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.busqueCpfCnpj")',
                                        :disabled='loadingResumo.loadingDiagnostico || loadingResumo.loadingSaldo',
                                        v-mask='["###.###.###-##", "##.###.###/####-##"]',
                                        clearable
                                    )
                                    el-button(
                                        type='primary',
                                        @click.prevent='buscarInforCpfCnpj'
                                    ) {{ $t('mensagens.comuns.buscar') }}

                        .box-inserir-dados-analise__conteudo__bloco_pesquisa-por-territorio.width-direito
                            el-form-item(prop='territorioSelecionado')
                                template(slot='label')
                                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.pesquisaCar') }}
                                    el-tooltip(
                                        :content='$t("mensagens.relatorioRastreabilidade.cadastro.informeCarVinculadoProdutor")',
                                        placement='top'
                                    )
                                        i.el-icon-info.dados-manual

                                .input-pesquisa-por-territorio
                                    el-input(
                                        v-model='formularioCadastroTerritorio.territorioSelecionado',
                                        @clear='limparTerritorios',
                                        :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.busqueCar")',
                                        :disabled='loadingResumo.loadingDiagnostico || loadingResumo.loadingSaldo',
                                        v-mask='["AA-#######-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX"]',
                                        clearable
                                    )

                                //- .input-pesquisa-por-territorio
                                    el-select(
                                        v-model='formularioCadastroTerritorio.territorioSelecionado',
                                        :loading='buscandoTerritorio',
                                        :loading-text='textoBuscandoTerritorio',
                                        filterable,
                                        remote,
                                        clearable,
                                        @clear='limparTerritorios',
                                        reserve-keyword,
                                        placeholder='Busque por CAR',
                                        remote-show-suffix,
                                        :remote-method='fetchTerritorios',
                                        :disabled='loadingResumo.loadingDiagnostico || loadingResumo.loadingRaio || loadingResumo.loadingSaldo'
                                    )
                                        el-option(
                                            v-for='territorio in territorios',
                                            :key='territorio.nome + territorio.id',
                                            :label='territorio.nome',
                                            :value='territorio'
                                        )
                                        template(
                                            v-if='inputValue.length >= 5 && !territorios.length && !buscandoTerritorio',
                                            #empty
                                        )
                                            .inserir-dados-manual-sem-resultado(
                                                v-if='!verificarCar(inputValue)'
                                            )
                                                p Nenhum resultado encontrado.

                                            .inserir-dados-manual-sem-resultado-cadastro-car(
                                                v-else
                                            )

                        .box-inserir-dados-analise__conteudo__bloco__buttons
                            el-button(
                                type='primary',
                                icon='el-icon-search',
                                @click.prevent='validarDadosRelatorioAnalise',
                                :disabled='false'
                            ) {{ $t('mensagens.comuns.consultar') }}

                transition(name='el-fade-in')
                    .box-inserir-dados-analise__conteudo__bloco(
                        v-if='showResumoElegibilidade'
                    )
                        .box-inserir-dados-analise__conteudo__bloco__elegibilidade.width-direito
                            .cabecalho-resumo-elegibilidade
                                .analise-elegibilidade-codigo-car
                                    span CAR:
                                    span.car-codigo {{ formularioCadastroTerritorio.territorioSelecionado }}
                                .analise-elegibilidade-span
                                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.analiseRastreabilidade') }}:
                                    .analise-elegibilidade-span__resultado(
                                        v-if='resultadoElegibilidade !== "INDEFINIDO"'
                                    )
                                        i.flow.flow-warning-sign(
                                            :class='corStatus[resultadoElegibilidade].classeCor'
                                        )
                                        span(
                                            :class='corStatus[resultadoElegibilidade].classeCor'
                                        ) {{ corStatus[resultadoElegibilidade].status }}
                                    .analise-elegibilidade-span__resultado(
                                        v-else
                                    ) -

                            #resumoDiv.resumo-elegibilidade
                                .resumo-elegibilidade__diagnostico.resumo-elegibilidade-item
                                    |
                                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.diagnosticoSocioambiental') }}:
                                    SkeletonBlocoResumoAnalise.resumo-elegibilidade__diagnostico--item(
                                        :carregando='loadingResumo.loadingDiagnostico'
                                    )
                                        span(
                                            v-if='dadosAnaliseElegibilidade.dadosDiagnostico.resultadoDiagnosticoRastreabilidade === null'
                                        )
                                            | -
                                        span(
                                            v-else,
                                            :class='statusDiagnostico[dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade].corClasse'
                                        ) {{ statusDiagnostico[dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade].status }}

                                .resumo-elegibilidade__capacidade-produtiva.resumo-elegibilidade-item
                                    |
                                    span {{ $t('mensagens.relatorioRastreabilidade.cadastro.capacidadeProdutiva') }}:
                                    SkeletonBlocoResumoAnalise.resumo-elegibilidade__capacidade-produtiva--item(
                                        :carregando='loadingResumo.loadingDiagnostico'
                                    )
                                        span(
                                            v-if='dadosAnaliseElegibilidade.dadosDiagnostico.resultadoDiagnosticoRastreabilidade === null'
                                        )
                                            | -
                                        span(
                                            v-else,
                                            :class='statusDiagnostico[dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade].corClasse'
                                        ) {{ dadosAnaliseElegibilidade.dadosBuscaSaldo.capacidadeProdutiva }} t

                                //- .resumo-elegibilidade__saldo.resumo-elegibilidade-item
                                //-     span Saldo disponível:
                                //-     SkeletonBlocoResumoAnalise.resumo-elegibilidade__saldo--item(
                                //-         :carregando='loadingResumo.loadingSaldo'
                                //-     )
                                //-         span(
                                //-             v-if='dadosAnaliseElegibilidade.dadosBuscaSaldo.saldoCARcapacidadeProdutiva === null && dadosAnaliseElegibilidade.dadosBuscaSaldo.capacidadeProdutiva === null'
                                //-         )
                                //-             | -
                                //-         span(
                                //-             v-else,
                                //-             :class='dadosAnaliseElegibilidade.dadosBuscaSaldo.saldoCARcapacidadeProdutiva <= 0 ? "status-danger" : "status-sucess"'
                                //-         ) {{ dadosAnaliseElegibilidade.dadosBuscaSaldo.saldoCARcapacidadeProdutiva }} ({{ dadosAnaliseElegibilidade.dadosBuscaSaldo.calculoSaca.saldoCARcapacidadeProdutivaSaca }} sc)

                                .resumo-elegibilidade__link-detalhar.resumo-elegibilidade-item(
                                    v-if='dadosAnaliseElegibilidade.dadosDiagnostico.nivelAlertaRastreabilidade !== null && dadosAnaliseElegibilidade.dadosBuscaSaldo.capacidadeProdutiva !== null',
                                    @click.prevent='modalAnaliseElegibilidade'
                                )
                                    span {{ $t('mensagens.comuns.verDetalhes') }}
                                    i.mdi.mdi-arrow-right
                                .resumo-elegibilidade__link-detalhar(v-else)

                        .box-inserir-dados-analise__conteudo__bloco__volume
                            el-form(
                                label-position='top',
                                :model='formularioCadastroTerritorio',
                                :rules='formularioCadastroTerritorioRegrasVolume',
                                ref='formularioCadastroTerritorioVolume'
                            )
                                .box-inserir-dados-analise__conteudo__bloco_pesquisa-por-volume.width-esquerdo
                                el-form-item(prop='volumeTerritorio')
                                    template(slot='label')
                                        span {{ $t('mensagens.relatorioRastreabilidade.cadastro.volumeT') }}

                                    el-input.width-total(
                                        :placeholder='$t("mensagens.relatorioRastreabilidade.cadastro.inserirVolume")',
                                        v-model='formularioCadastroTerritorio.volumeTerritorio',
                                        @blur='volumeRecebidoFormatado',
                                        :disabled='loadingResumo.loadingDiagnostico || loadingResumo.loadingSaldo'
                                    )

                        .box-inserir-dados-analise__conteudo__bloco__buttons.width-esquerdo
                            el-button(
                                type='primary',
                                icon='el-icon-plus',
                                :loading='territorioSendoInserido',
                                @click.prevent='validarAdicionarListagem'
                            ) {{ $t('mensagens.relatorioRastreabilidade.cadastro.adicionarLista') }}

        ModalCadastrarTerritorioManual(
            :mostrar='showModalCadastroTerritorio',
            @fechar='showModalCadastroTerritorio = false',
            @territorio-cadastrado='definirVolumeTerritorioCadastrado'
        )

        ModalAnaliseElegibilidadeRelatorio(
            :show='ativarModalAnaliseElegibilidade',
            :dados='dadosAnaliseElegibilidade',
            @handleCloseModalAnaliseElegibidade='ativarModalAnaliseElegibilidade = false',
            :idMapa='"mapaAnaliseEleigibilidadeRelatorio"'
        )

        .modal-definir-volume(v-if='showModalDadosCadastroManual')
            ModalDadosCadastroManual(
                :mostrar='showModalDadosCadastroManual',
                @fechar='showModalDadosCadastroManual = false',
                :territorio='territorioCadastrado',
                @definir-volume='definirVolume'
            )
        .modal-selecionar-cars-cpf-cnp
            ModalSelecionarCarsCpfCnp(
                :show='mostrarModalDadosCarsCpfCnp',
                :cpfCnpj='formularioCadastroTerritorio.cpfCnpj',
                :dados='dadosCarsCpfCnp',
                @voltar='mostrarModalDadosCarsCpfCnp = false',
                @retornarDadosSelecionados='exibirDadosCarsCpfCnp'
            )
    .modal-media-capacidade-produtiva(v-if='showModalDadosCapacidadeProdutiva')
        el-dialog(
            :visible.sync='showModalDadosCapacidadeProdutiva',
            :close-on-click-modal='false'
        )
            template(slot='title')
                .modal-media-capacidade-produtiva__title
                    i.el-icon-error
                    span {{ dadosMediaCapacidadeProdutivaRegional.title }}

            p {{ dadosMediaCapacidadeProdutivaRegional.message }}

            .modal-media-capacidade-produtiva__linha
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label Território
                    p {{ dadosMediaCapacidadeProdutivaRegional.territorioNome }}
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label Área
                    p {{ dadosMediaCapacidadeProdutivaRegional.territorioArea }}
            .modal-media-capacidade-produtiva__linha
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label Volume máximo permitido
                    p.modal-media-capacidade-produtiva__permitido {{ dadosMediaCapacidadeProdutivaRegional.volumeMaximoPermitido }}
                .modal-media-capacidade-produtiva__coluna
                    span.modal-media-capacidade-produtiva__label Volume adicionado
                    p.modal-media-capacidade-produtiva__excedente {{ formularioCadastroTerritorio.volumeTerritorio + ' t' }}

            hr

            el-table(
                :data='dadosMediaCapacidadeProdutivaRegional.medias',
                style='width: 100%'
            )
                el-table-column(
                    prop='estadoNome',
                    label='Estado',
                    align='center',
                    width='100'
                )
                el-table-column(prop='mediaRegionalPorUnidade', align='center')
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='$t("mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.modalAnaliseElebilidade.fonte") + dadosMediaCapacidadeProdutivaRegional.fonte',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span Média regional
                el-table-column(
                    prop='mediaPermitidaPorUnidade',
                    label='Média permitida',
                    align='center'
                )
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.mediaPermitidaPorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span Máximo permitido
                el-table-column(
                    prop='mediaTerritorioPorUnidade',
                    align='center'
                )
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.mediaTerritorioPorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span Média do volume inserido
                el-table-column(align='center')
                    template(slot='header', slot-scope='scope')
                        el-tooltip(
                            :content='dadosMediaCapacidadeProdutivaRegional.excedentePorUnidadeTooltip',
                            placement='top'
                        )
                            i.el-icon-info.modal-media-capacidade-produtiva__info
                        span Excedente em relação ao máximo permitido
                    template(slot-scope='scope')
                        div
                            span.modal-media-capacidade-produtiva__excedente {{ scope.row.excedentePorUnidade }}
            span.dialog-footer(slot='footer')
                el-button(
                    type='primary',
                    @click='showModalDadosCapacidadeProdutiva = false'
                ) Ok
</template>

<script>
import ModalDadosCadastroManual from '@/components/contratosOriginacao/SubEmpresaModalRevisarTerritorio.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import ModalCadastrarTerritorioManual from '@/components/contratosOriginacao/SubEmpresaModalCadastrarTerritorio.vue';
import ModalSelecionarCarsCpfCnp from '@/components/contratosOriginacao/ModalSelecionarCarsCpfCnpj.vue';
import CarUtils from '@/utils/CarUtils';
import formatters from '@/utils/formatters';
import SkeletonBlocoResumoAnalise from '@/components/contratosOriginacao/SkeletonBlocoResumoAnaliseEligibilidade.vue';
import ModalAnaliseElegibilidadeRelatorio from '@/components/relatorioRastreabilidade/ModalAnaliseElegibilidadeRelatorio.vue';
import validators from '@/utils/validators';
import CarService from '@/services/car/CarService';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import MunicipioService from '@/services/MunicipioService';
import i18n from '@/main';

export default {
    name: 'BlocoInserirDadosAnaliseRastreabilidade',
    components: {
        ModalCadastrarTerritorioManual,
        ModalDadosCadastroManual,
        SkeletonBlocoResumoAnalise,
        ModalAnaliseElegibilidadeRelatorio,
        ModalSelecionarCarsCpfCnp,
        validators
    },

    props: {
        dados: {
            type: Object,
            required: true
        }
    },

    mounted() {
        this.buscarSafras();
    },

    data() {
        const validarVolume = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Campo obrigatório'));
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        'Não pode haver pontos, somente virgulas e números'
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().startsWith(',')
            ) {
                callback(new Error('Número mal formatado'));
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(new Error('Valor deve ser maior que zero'));
                return;
            }

            callback();
        };
        return {
            formularioCadastroTerritorio: {
                safra: '',
                territorioSelecionado: '',
                cpfCnpj: '',
                volumeTerritorio: ''
            },
            formularioCadastroTerritorioRegras: {
                territorioSelecionado: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.informeUmCar'
                        ),
                        validator: this.checkRuleCAR,
                        trigger: 'change'
                    }
                ],
                cpfCnpj: [
                    {
                        required: true,
                        validator: this.checkRuleCpfCnpj,
                        trigger: 'blur'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
                        ),
                        trigger: 'change'
                    }
                ]
            },
            formularioCadastroTerritorioRegrasVolume: {
                volumeTerritorio: [
                    {
                        required: true,
                        validator: validarVolume,
                        trigger: 'blur'
                    }
                ]
            },
            territorios: [],
            numeroContrato: this.$route.params.numeroContrato,
            showModalCadastroTerritorio: false,
            showModalDadosCadastroManual: false,
            territorioCadastrado: {},
            buscandoTerritorio: true,
            inputValue: '',
            textoBuscandoTerritorio: 'Mínimo 3 caracteres',
            showModalDadosCapacidadeProdutiva: false,
            dadosMediaCapacidadeProdutivaRegional: {
                medias: []
            },
            dadosTerritorioListagem: {
                cars: [],
                idTerritorio: null,
                mensagemCadastroSucesso: '',
                nomeTerritorio: '',
                numeroCar: null,
                numeroContrato: '',
                volume: null
            },
            corStatus: {
                ELEGIVEL: {
                    classeCor: 'status-sucess',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.elegivel'
                    )
                },
                INELEGIVEL: {
                    classeCor: 'status-danger',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inelegivel'
                    )
                },
                INDEFINIDO: {
                    classeCor: '',
                    status: ''
                },
                ALERTA: {
                    classeCor: 'status-laranja',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.comAlerta'
                    )
                }
            },
            statusDiagnostico: {
                MEDIO_ALTO: {
                    corClasse: 'status-laranja',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.alerta'
                    )
                },
                MEDIO: {
                    corClasse: 'status-amarelo',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.alerta'
                    )
                },
                BAIXO: {
                    corClasse: 'status-sucess',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.conforme'
                    )
                },
                ALTO: {
                    corClasse: 'status-danger',
                    status: this.$t(
                        'mensagens.relatorioRastreabilidade.comuns.inconforme'
                    )
                }
            },
            resultadoElegibilidade: 'INDEFINIDO',
            limiteRaio: 200,
            dadosAnaliseElegibilidade: {
                elegibilidade: '',
                valor: '',
                cpfCnpj: '',
                safraNome: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            },
            bloquearInput: false,
            loadingResumo: {
                loadingDiagnostico: false,
                loadingSaldo: false,
                analiseElegibilidade: false
            },
            loading: {
                safras: true
            },
            ativarModalAnaliseElegibilidade: false,
            territorioSendoInserido: false,
            mostrarModalDadosCarsCpfCnp: false,
            dadosCarsCpfCnp: [],
            showResumoElegibilidade: false,
            safras: [],
            loadingCpfCnpj: false
        };
    },

    watch: {
        'formularioCadastroTerritorio.territorioSelecionado': function (
            newVal,
            oldVal
        ) {
            this.showResumoElegibilidade = false;
        },
        'formularioCadastroTerritorio.cpfCnpj': function (newVal, oldVal) {
            this.showResumoElegibilidade = false;
        },
        locale: function () {
            this.formularioCadastroTerritorioRegras.safra[0].message = this.$t(
                'mensagens.relatorioRastreabilidade.cadastro.campoObrigatorio'
            );

            this.formularioCadastroTerritorioRegras.territorioSelecionado[0].message =
                this.$t(
                    'mensagens.relatorioRastreabilidade.cadastro.informeUmCar'
                );

            this.updateCorStatus();
            this.updateStatusDiagnostico();
        }
    },

    computed: {
        cpfCnpjValido() {
            if (this.formularioCadastroTerritorio.cpfCnpj) {
                return validators.validarCpfCnpj(
                    this.formularioCadastroTerritorio.cpfCnpj
                );
            }

            return false;
        },
        locale: function () {
            return i18n._vm.locale;
        }
    },

    methods: {
        async fetchTerritorios(filtro) {
            this.buscandoTerritorio = true;

            this.formularioCadastroTerritorio.territorioSelecionado =
                this.adicionarMascaraNaConsulta(filtro);

            filtro = this.formularioCadastroTerritorio.territorioSelecionado;

            if (filtro.length < 5) {
                this.textoBuscandoTerritorio = 'Mínimo 5 caracteres';
                this.territorios = [];
                this.inputValue = '';
                return;
            }

            if (filtro.length > 43) {
                this.textoBuscandoTerritorio = 'Máximo 43 caracteres';
                this.territorios = [];
                this.inputValue = '';
                return;
            }

            this.textoBuscandoTerritorio = 'Carregando...';
            this.inputValue = filtro;
            try {
                this.buscandoTerritorio = true;
                const { data } =
                    await ContratoOriginacaoServiceSubEmpresa.buscarTerritorioFiltro(
                        filtro
                    );
                if (CarUtils.isCar(filtro) && !data.length) {
                    this.formularioCadastroTerritorio.territorioSelecionado =
                        CarUtils.addMascaraCar(filtro);
                    this.inputValue = filtro;
                    this.buscandoTerritorio = false;
                } else {
                    this.territorios = data;
                }
                this.buscandoTerritorio = false;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.relatorioRastreabilidade.cadastro.erroBuscarDadosTerritorios'
                    )
                });
            }
        },

        validarAdicionarListagem() {
            this.$emit(
                'validarAdicionarListagem',
                this.formularioCadastroTerritorio.volumeTerritorio,
                this.formularioCadastroTerritorio.territorioSelecionado
            );
        },

        validarTerritorioManual() {
            let temErroForm = false;

            this.$refs['formularioCadastroTerritorioVolume'].validate(valid => {
                if (!valid) {
                    temErroForm = true;
                }
            });
            this.$refs['formularioCadastroTerritorio'].validate(valid => {
                if (!valid) {
                    temErroForm = true;
                }
            });
            if (!temErroForm) {
                this.adicionarTerritorioListagem();
            }
        },

        async adicionarTerritorioListagem() {
            this.territorioSendoInserido = true;
            this.dadosAnaliseElegibilidade.safraNome =
                this.formularioCadastroTerritorio.safra;

            var dadosRelatorioDiagnostico = {
                cpfCnpj: this.formularioCadastroTerritorio.cpfCnpj.replace(
                    /\D/g,
                    ''
                ),
                codigoCar:
                    this.formularioCadastroTerritorio.territorioSelecionado,
                volumeAdicionado: parseFloat(
                    this.formularioCadastroTerritorio.volumeTerritorio.replace(
                        ',',
                        '.'
                    )
                ),
                situacao:
                    this.dadosAnaliseElegibilidade.dadosDiagnostico
                        .resultadoDiagnosticoRastreabilidade,
                nivelAlerta:
                    this.dadosAnaliseElegibilidade.dadosDiagnostico
                        .nivelAlertaRastreabilidade,
                anoSafra: this.formularioCadastroTerritorio.safra,
                resultadoDiagnostico: JSON.stringify(
                    this.dadosAnaliseElegibilidade.dadosDiagnostico
                ),
                dataAnalise: this.dataAnaliseRastreabilidade(),
                idLinha: Math.floor(Math.random() * 1000000),
                dadosAnaliseElegibilidade: this.dadosAnaliseElegibilidade
            };

            this.$emit(
                'adicionarTerritorioRelatorioListagem',
                dadosRelatorioDiagnostico
            );

            this.$refs['formularioCadastroTerritorio'].resetFields();
            this.$refs['formularioCadastroTerritorioVolume'].resetFields();
            this.showResumoElegibilidade = false;

            this.territorioSendoInserido = false;
        },

        dataAnaliseRastreabilidade() {
            function getDateNow() {
                const now = new Date();
                const day = String(now.getDate()).padStart(2, '0');
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const year = now.getFullYear();
                const dateNow = `${day}/${month}/${year}`;
                return dateNow;
            }

            const currentDate = getDateNow();
            return currentDate;
        },

        exibirNotificacoesErros(error) {
            if (error.response.data.type === 'MEDIA_CAPACIDADE_REGIONAL') {
                this.exibirDadosCapacidadeMediaRegional(error);
            } else if (error.response.data.type === 'FORA_DO_RAIO_PERMITIDO') {
                this.$messageBox.alert(
                    error.response.data.message,
                    error.response.data.title,
                    {
                        confirmButtonText: 'Voltar',
                        type: 'warning'
                    }
                );
            } else {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
        },

        exibirDadosCapacidadeMediaRegional(error) {
            const {
                estadoNome,
                mediaRegionalPorUnidade,
                mediaPermitidaPorUnidade,
                mediaTerritorioPorUnidade,
                excedentePorUnidade,
                percentualExcedentePorUnidade
            } = error.response.data.output;

            const medias = [
                {
                    estadoNome,
                    mediaRegionalPorUnidade,
                    mediaPermitidaPorUnidade,
                    mediaTerritorioPorUnidade,
                    excedentePorUnidade,
                    percentualExcedentePorUnidade
                }
            ];

            this.dadosMediaCapacidadeProdutivaRegional = {
                title: error.response.data.title,
                message: error.response.data.message,
                medias,
                ...error.response.data.output
            };

            this.showModalDadosCapacidadeProdutiva = true;
        },

        cadastroTerritorio() {
            this.$refs['formularioCadastroTerritorio'].resetFields();
            this.showModalCadastroTerritorio = true;
        },

        definirVolumeTerritorioCadastrado(territorioCadastrado) {
            this.showModalCadastroTerritorio = false;
            this.territorioCadastrado = territorioCadastrado;
            this.formularioCadastroTerritorio.territorioSelecionado =
                territorioCadastrado.idTerritorio;

            setTimeout(() => (this.showModalDadosCadastroManual = true), 500);
        },
        definirVolume(volume) {
            this.formularioCadastroTerritorio.volumeTerritorio = volume;
            this.showModalDadosCadastroManual = false;
            this.adicionarTerritorioManual();
        },
        verificarCar(valor) {
            return CarUtils.isCar(valor);
        },
        limparTerritorios() {
            this.territorios = [];
            this.formularioCadastroTerritorio.territorioSelecionado = '';
            this.limparDadosResumo();
            this.$emit('bloqueioDeEdicao', false);
        },
        limparCPF() {
            this.formularioCadastroTerritorio.cpfCnpj = '';
            this.limparDadosResumo();
            this.$emit('bloqueioDeEdicao', false);
        },
        volumeRecebidoFormatado() {
            this.formularioCadastroTerritorio.volumeTerritorio =
                formatters.formatarTonelada(
                    this.formularioCadastroTerritorio.volumeTerritorio
                );
        },
        validarDadosRelatorioAnalise() {
            this.$emit('validarCamposDadosRelatorio');
        },

        validarRealizarResumo() {
            this.$refs['formularioCadastroTerritorio'].validate(valid => {
                if (valid) {
                    this.realizarResumo();
                } else {
                    return false;
                }
            });
        },

        async realizarResumo() {
            if (
                this.loadingResumo.loadingDiagnostico ||
                this.loadingResumo.loadingSaldo
            ) {
                return;
            }

            this.limparDadosResumo();
            if (this.formularioCadastroTerritorio.territorioSelecionado?.id) {
                const terriorioInserido = this.territorios.find(
                    objeto =>
                        objeto.id ===
                        this.formularioCadastroTerritorio.territorioSelecionado
                );

                if (terriorioInserido) {
                    this.dadosAnaliseElegibilidade.valor =
                        terriorioInserido.nome;
                } else {
                    this.dadosAnaliseElegibilidade.valor =
                        this.formularioCadastroTerritorio.territorioSelecionado;
                }
            }
            this.dadosAnaliseElegibilidade.cpfCnpj =
                this.formularioCadastroTerritorio.cpfCnpj;
            this.showResumoElegibilidade = true;
            this.realizarDiagnostico();
            this.buscarSaldo();
            this.analisarElegibilidade();

            this.$emit('bloqueioDeEdicao', true);
        },
        async realizarDiagnostico() {
            this.loadingResumo.loadingDiagnostico = true;
            const dadosParaEnvio = {
                cpfCnpjRepresentante: this.formularioCadastroTerritorio.cpfCnpj,
                codigoCar: this.formularioCadastroTerritorio
                    .territorioSelecionado?.nome
                    ? this.formularioCadastroTerritorio.territorioSelecionado
                          .nome
                    : this.formularioCadastroTerritorio.territorioSelecionado
            };

            try {
                const response =
                    await ContratoOriginacaoServiceSubEmpresa.realizarDiagnosticoSocioambientalPreInsercaoTerritorio(
                        dadosParaEnvio
                    );
                this.dadosAnaliseElegibilidade.dadosDiagnostico = response.data;

                this.analisarElegibilidade();
            } catch (error) {
                if (
                    [
                        'O número do CAR informado não foi encontrado na vega API.',
                        'El número de CAR proporcionado no se encontró en la API de Vega.',
                        'The CAR number provided was not found in the vega API.'
                    ].includes(error.response.data.message)
                ) {
                    this.loadingResumo.loadingDiagnostico = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingDiagnostico = false;
        },
        async calcularRaio() {
            this.loadingResumo.loadingRaio = true;

            const dadosParaEnvio = {
                idTerritorio: this.formularioCadastroTerritorio
                    .territorioSelecionado?.id
                    ? this.formularioCadastroTerritorio.territorioSelecionado
                          ?.id
                    : null,
                numeroCar: this.formularioCadastroTerritorio
                    .territorioSelecionado?.nome
                    ? this.formularioCadastroTerritorio.territorioSelecionado
                          .codigoCar
                    : this.formularioCadastroTerritorio.territorioSelecionado,
                numeroContrato: this.numeroContrato
            };

            try {
                const response =
                    await MunicipioService.ValidarMunicipioRaioAceiteCar(
                        dadosParaEnvio
                    );
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = response.data;

                this.analisarElegibilidade();
            } catch (error) {
                if (
                    [
                        'O número do CAR informado não foi encontrado na vega API.',
                        'El número de CAR proporcionado no se encontró en la API de Vega.',
                        'The CAR number provided was not found in the vega API.'
                    ].includes(error.response.data.message)
                ) {
                    this.loadingResumo.loadingRaio = false;
                    return;
                } else {
                    this.$notify.error({
                        message: error.response.data.message
                    });
                }
            }
            this.loadingResumo.loadingRaio = false;
        },
        async buscarSaldo() {
            this.loadingResumo.loadingSaldo = true;

            const dadosParaEnvio = {
                codigoCar: this.formularioCadastroTerritorio
                    .territorioSelecionado?.nome
                    ? this.formularioCadastroTerritorio.territorioSelecionado
                          .nome
                    : this.formularioCadastroTerritorio.territorioSelecionado,
                idTerritorio: this.formularioCadastroTerritorio
                    .territorioSelecionado?.idTerritorio
                    ? this.formularioCadastroTerritorio.territorioSelecionado
                          .idTerritorio
                    : 0,
                nomeMaterial: this.dados.nomeCultura,
                anoSafra: this.formularioCadastroTerritorio.safra,
                numeroContrato: this.dados.numeroContrato
            };

            try {
                const response =
                    await ContratoOriginacaoServiceSubEmpresa.buscarSaldo(
                        dadosParaEnvio
                    );
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo = response.data;

                this.analisarElegibilidade();
                this.$emit(
                    'capacidadeProdutiva',
                    this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                        .capacidadeProdutiva
                );
            } catch (error) {
                this.$notify.error({
                    message: error.response.data.message
                });
            }
            this.loadingResumo.loadingSaldo = false;
        },
        analisarElegibilidade() {
            if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .resultadoDiagnosticoRastreabilidade === null
            ) {
                return;
            }

            if (
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCARcapacidadeProdutiva === null
            ) {
                return;
            }
            this.resultadoElegibilidade = 'INDEFINIDO';
            if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .resultadoDiagnosticoRastreabilidade === 'INCONFORME'
            ) {
                this.resultadoElegibilidade = 'INELEGIVEL';
            } else if (
                this.dadosAnaliseElegibilidade.dadosDiagnostico
                    .nivelAlertaRastreabilidade === 'MEDIO_ALTO'
            ) {
                this.resultadoElegibilidade = 'ALERTA';
            } else {
                this.resultadoElegibilidade = 'ELEGIVEL';
            }

            if (
                this.dadosAnaliseElegibilidade.dadosBuscaSaldo
                    .saldoCARcapacidadeProdutiva <= 0
            ) {
                this.resultadoElegibilidade = 'INELEGIVEL';
            }

            this.dadosAnaliseElegibilidade.elegibilidade =
                this.resultadoElegibilidade;

            var resumoDiv = document.getElementById('resumoDiv');

            if (this.resultadoElegibilidade === 'ELEGIVEL') {
                resumoDiv.style.backgroundColor = '#3591381A';
            } else if (this.resultadoElegibilidade === 'ALERTA') {
                resumoDiv.style.backgroundColor = '#F9935A1A';
            } else if (this.resultadoElegibilidade === 'INELEGIVEL') {
                resumoDiv.style.backgroundColor = '#EC32321A';
            } else {
                resumoDiv.style.backgroundColor = '';
            }
        },
        modalAnaliseElegibilidade() {
            if (
                this.loadingResumo.loadingDiagnostico ||
                this.loadingResumo.loadingSaldo
            ) {
                return;
            }
            this.dadosAnaliseElegibilidade.safraNome =
                this.formularioCadastroTerritorio.safra;
            this.ativarModalAnaliseElegibilidade = true;
        },
        limparDadosResumo() {
            this.showResumoElegibilidade = false;
            this.formularioCadastroTerritorio.volumeTerritorio = '';
            this.dadosAnaliseElegibilidade = {
                valor: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                }
            };
            this.resultadoElegibilidade = 'INDEFINIDO';
        },

        checkRuleCpfCnpj(rule, value, callback) {
            if (
                !validators.validarCpfCnpj(
                    this.formularioCadastroTerritorio.cpfCnpj
                ) ||
                !this.formularioCadastroTerritorio.cpfCnpj
            ) {
                return callback(
                    new Error(
                        this.$t(
                            'mensagens.relatorioRastreabilidade.cadastro.informeCpfCnpjValido'
                        )
                    )
                );
            }
            callback();
        },

        checkRuleCAR(rule, value, callback) {
            if (
                !CarUtils.isCar(value) ||
                !this.formularioCadastroTerritorio.territorioSelecionado
            ) {
                return callback(new Error('Informe um CAR válido'));
            }
            callback();
        },

        adicionarMascaraNaConsulta(consulta) {
            consulta = consulta.replace(/[^\w\s]/gi, '');
            const consultaUpperCase =
                CarUtils.addMascaraCar(consulta).toUpperCase();
            if (consultaUpperCase.length >= 43) {
                return consultaUpperCase.substring(0, 43);
            }
            return consultaUpperCase;
        },

        async buscarInforCpfCnpj() {
            if (
                !this.formularioCadastroTerritorio.cpfCnpj ||
                this.loadingCpfCnpj
            ) {
                return;
            }
            this.loadingCpfCnpj = true;
            this.dadosCarsCpfCnp = [];
            try {
                const cpfCnpj =
                    this.formularioCadastroTerritorio.cpfCnpj.replace(
                        /\D/g,
                        ''
                    );

                try {
                    const { data } =
                        await CarService.buscarCarPorCpfCnpjVinculadoGeral(
                            cpfCnpj
                        );

                    if (data.existemDados) {
                        if (data.carsEstados.length) {
                            if (data.carsEstados.length > 1) {
                                data.carsEstados.forEach(item => {
                                    this.dadosCarsCpfCnp = [
                                        ...this.dadosCarsCpfCnp,
                                        item.data
                                    ];
                                });
                            } else {
                                this.dadosCarsCpfCnp = [
                                    ...data.carsEstados[0].data
                                ];
                            }
                        }
                        if (data.carsBase.length) {
                            this.dadosCarsCpfCnp = [
                                ...this.dadosCarsCpfCnp,
                                ...data.carsBase
                            ];
                        }

                        if (this.dadosCarsCpfCnp.length) {
                            this.dadosCarsCpfCnp.forEach(item => {
                                if (!item.hasOwnProperty('origem')) {
                                    item.origem = item.uf
                                        ? 'SICAR - ' + item.uf
                                        : 'Mod. Territórios';
                                }
                            });

                            this.dadosCarsCpfCnp.sort((a, b) => {
                                const origemA = a.origem.startsWith('SICAR - ')
                                    ? a.origem.slice(8)
                                    : a.origem;
                                const origemB = b.origem.startsWith('SICAR - ')
                                    ? b.origem.slice(8)
                                    : b.origem;
                                return origemA.localeCompare(origemB);
                            });
                        }

                        this.mostrarModalDadosCarsCpfCnp = true;
                    } else {
                        this.alertSemDadosCars();
                    }
                } catch (error) {
                    this.$notify.error({
                        message:
                            'Houve um erro na requisição. Por favor, tente novamente.'
                    });
                }
            } catch (error) {}
            this.loadingCpfCnpj = false;
        },
        exibirDadosCarsCpfCnp(car) {
            if (car === undefined) {
                this.mostrarModalDadosCarsCpfCnp = false;
            } else {
                this.formularioCadastroTerritorio.territorioSelecionado = car;
                this.mostrarModalDadosCarsCpfCnp = false;
            }
        },
        alertSemDadosCars() {
            try {
                this.$messageBox.alert(
                    `O sistema não identificou um imóvel associado ao CPF/CNPJ informado, busque por outro CPF/CNPJ ou adicione o número do CAR para vincula-lo.`,
                    'Aviso',
                    {
                        confirmButtonText: 'Ok',
                        type: 'info',
                        customClass: 'message-box-infor-sub-empresa-manual'
                    }
                );
            } catch (erro) {}
        },

        async buscarSafras() {
            try {
                this.loading.safras = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.safras = data;
                this.loading.safras = false;
            } catch (error) {
                this.$notify.error('Ocorreu um erro ao buscar as safras');
            }
        },

        validateForm() {
            this.$refs['formularioCadastroTerritorio'].validate(valid => {
                if (valid) {
                } else {
                    this.$emit('handleValidationFailed');
                }
            });
        },

        validateFormVolume() {
            this.$refs['formularioCadastroTerritorioVolume'].validate(valid => {
                if (valid) {
                } else {
                    this.$emit('handleValidationFailed');
                }
            });
        },

        updateCorStatus() {
            this.corStatus.ELEGIVEL.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.elegivel'
            );
            this.corStatus.INELEGIVEL.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.inelegivel'
            );
            this.corStatus.ALERTA.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.comAlerta'
            );
        },

        updateStatusDiagnostico() {
            this.statusDiagnostico.MEDIO_ALTO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.alerta'
            );
            this.statusDiagnostico.MEDIO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.alerta'
            );
            this.statusDiagnostico.BAIXO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.conforme'
            );
            this.statusDiagnostico.ALTO.status = this.$t(
                'mensagens.relatorioRastreabilidade.comuns.inconforme'
            );
        }
    }
};
</script>

<style lang="scss">
#bloco-inserir-dados-analise-rastreabilidade {
    width: 100%;

    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    el-card {
        margin-top: 10px;
        display: flex;
    }

    .box-inserir-dados-analise {
        // height: 333px;

        .width-direito {
            width: 68%;
        }
        .width-esquerdo {
            width: 22%;
        }
    }

    .box-inserir-dados-analise__conteudo {
        display: flex;
        flex-direction: column;
        align-content: space-around;
        // min-height: 325px;
        justify-content: space-between;

        .box-inserir-dados-analise__conteudo__bloco {
            margin-bottom: 15px;
            font-size: 16px;
            display: flex;
            gap: 15px;

            .box-inserir-dados-analise__conteudo__bloco__buttons {
                display: flex;
                justify-content: flex-end;
                gap: 15px;
                margin-top: 39px;

                button.el-button.el-button--primary {
                    height: 40px;
                    width: 210px;
                }
            }

            .box-inserir-dados-analise__conteudo__bloco__elegibilidade {
                display: flex;
                flex-direction: column;
                justify-content: center;
                gap: 5px;

                .analise-elegibilidade-span {
                    display: flex;
                    gap: 5px;
                    align-items: center;
                }

                span {
                    font-weight: bold;
                    color: var(--primary);
                    font-size: 14px;
                }

                .status-amarelo {
                    font-weight: bold;
                    color: #bfae19;
                    font-size: 14px;
                    margin-left: 4px;
                }

                .status-laranja {
                    font-weight: bold;
                    color: var(--warning);
                    font-size: 14px;
                    margin-left: 4px;
                }

                .status-danger {
                    font-weight: bold;
                    color: var(--danger);
                    font-size: 14px;
                    margin-left: 4px;
                }

                .status-sucess {
                    font-weight: bold;
                    color: var(--green);
                    font-size: 14px;
                    margin-left: 4px;
                }

                .cabecalho-resumo-elegibilidade {
                    display: flex;
                    gap: 44px;
                    align-items: center;

                    .analise-elegibilidade-codigo-car {
                        font-weight: bold;
                        display: flex;
                        gap: 5px;

                        span.car-codigo {
                            font-weight: normal;
                            color: #303133;
                            font-size: 14px;
                        }
                    }
                }

                .resumo-elegibilidade {
                    display: flex;
                    justify-content: space-between;
                    gap: 5px;
                    align-items: center;
                    flex-wrap: wrap;
                    background-color: #e7e7e7;
                    border-radius: 5px;
                    padding: 8px 8px;
                    min-height: 48px;

                    .resumo-elegibilidade-item {
                        display: flex;
                        gap: 5px;
                        align-items: center;
                        min-height: 30px;
                    }

                    .resumo-elegibilidade__link-detalhar {
                        min-width: 114px;

                        span,
                        i.mdi.mdi-arrow-right {
                            margin-left: 5px;
                            text-decoration: none;
                            color: #1989fa;
                            cursor: pointer;
                        }
                    }

                    .resumo-elegibilidade__link-detalhar:hover {
                        span,
                        i.mdi.mdi-arrow-right {
                            text-decoration: underline;
                        }
                    }
                    .resumo-elegibilidade__saldo--item {
                        min-width: 120px;
                    }
                    .resumo-elegibilidade__diagnostico--item {
                        min-width: 80px;
                    }
                    .resumo-elegibilidade__distancia--item {
                        min-width: 100px;
                    }
                }
            }
        }
    }

    .box-inserir-dados-analise__conteudo__bloco_pesquisa {
        flex-direction: row;
        display: flex;
        justify-content: space-between;
        gap: 15px;
        width: 100%;

        .box-inserir-dados-analise__conteudo__bloco_pesquisa-por-territorio {
            display: flex;
            flex-direction: column;

            .input-pesquisa-por-territorio {
                display: flex;

                .el-select {
                    width: 100%;
                }

                .el-button {
                    height: 40px;
                    min-width: 210px;
                }
            }

            .input-pesquisa-por-territorio.input-car-cpf-cnpj {
                display: flex;
                gap: 8px;
            }
        }
    }

    .modal-media-capacidade-produtiva {
        .modal-media-capacidade-produtiva__title {
            .el-icon-error {
                margin-right: 5px;
                color: var(--danger);
                font-size: 24px;
            }
        }

        .modal-media-capacidade-produtiva__info {
            margin-right: 5px;
            color: var(--secondary-font-color);
        }

        .modal-media-capacidade-produtiva__label {
            font-weight: bold;
            margin-right: 5px;
            color: var(--primary);
        }

        .modal-media-capacidade-produtiva__excedente {
            color: var(--danger);
            font-weight: bold;
        }

        .modal-media-capacidade-produtiva__permitido {
            color: var(--success);
            font-weight: bold;
        }

        .el-dialog__header {
            display: flex;
            align-items: flex-end;

            span {
                font-size: 18px;
            }
        }

        .el-dialog__body {
            font-size: 14px;
            padding: 20px 20px;
        }

        .modal-media-capacidade-produtiva__linha {
            display: flex;
            justify-content: space-between;
            gap: 30px;
        }

        .modal-media-capacidade-produtiva__coluna {
            width: 100%;
        }
    }

    i.el-tooltip.el-icon-info.dados-manual {
        margin-left: 4px;
    }
}

.inserir-dados-manual-sem-resultado {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 5px;
    text-align: center;
    justify-content: center;
    p {
        padding: 0;
        margin-top: 7px;
        margin-bottom: 5px;
    }
    .btn-cadastro {
        border-radius: 20px !important;
        color: #000000;
    }
}
.el-select-dropdown.el-popper
    > .inserir-dados-manual-sem-resultado-cadastro-car,
.inserir-dados-manual-sem-resultado-cadastro-car + .popper__arrow {
    display: none !important;
    min-width: 0px !important;
}
.message-box-infor-sub-empresa-manual {
    .el-message-box__btns {
        justify-content: end !important;
    }
}
</style>
